module.exports = __webpack_public_path__ + "static/mobility-category-6077b0f06257571b5103151917b9d91f.png";